<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container" v-on:click.stop="">
                    <h2 class="fs18 mb8">{{ params.title }}が完了しました</h2>
                    <div class="modal-body radius8 pd24 mt8p mb8p">
                        <slot name="body">
                            <p class="fs14 mb16">{{ params.message }}</p>
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button type="button" class="button fs16 w50p mt16 mb0 pd16 radius200" v-bind:disabled="this.button" @click="closeModal()">{{ params.buttonMessage }}</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>

export default {
  data () {
    return {
      button: false
    }
  },
  props: ['params'],
  methods: {
    closeModal () {
      this.reloadPage()
    },
    reloadPage () {
      this.$router.go({
        path: this.$router.currentRoute.path,
        query: {
          tsid: this.$route.query.tsid,
          otoken: this.$route.query.otoken,
          popinfo_id: this.$route.query.popinfoid,
          ss_code: this.$route.query.ssCode,
          appVersion: this.$route.query.appVersion,
          platform: this.$route.query.platform,
          osVersion: this.$route.query.osVersion
        },
        force: true
      })
    }
  }
}
</script>
